import React from 'react';
import {FormField, DatePickerPopup} from 'components';
import {moment, useField, useFocusPopup} from 'helpers';
import css from './edit.module.scss';

export function Date(props) {
  const [ field, , { setValue } ] = useField(props);
  const popup = useFocusPopup(DatePickerPopup, {
    ...props,
    ...field,
    setValue,
    className: 'adjacent',
    deps: [ field.value ],
  });
  return (
    <FormField {...props} value={field.value} {...popup} clear={!props.required && (() => setValue(''))}>
      <b className={css.value}>
        { field.value && moment.unix(field.value).format() }
      </b>
    </FormField>
  );
}
